import React, { Component } from "react";
import Styles from "./styles.css";
import { CONTEXT_ROOT } from "../../utils";

export class SelectPlan extends Component {
  state = {};
  OnFlatProceed() {
    const { pathName, flatSearch,queryRefParam } = this.props;
    const queryparam=!!queryRefParam?"?ref="+queryRefParam+"&"+flatSearch:"?"+flatSearch;
    window.location.replace(`${CONTEXT_ROOT}` / pathName +queryparam);
  }
  OnFlexProceed() {
    const { pathName, flexSearch,queryRefParam } = this.props;
    const queryparam=!!queryRefParam?"?ref="+queryRefParam+"&"+flexSearch:"?"+flexSearch;
    window.location.replace(`${CONTEXT_ROOT}` / pathName + queryparam);
  }
  componentDidMount() {
    const {queryPlanParam,queryRefParam}=this.props;
      if(queryPlanParam===0) {
        var refresh = !!queryRefParam?window.location.protocol + "//" + window.location.host + window.location.pathname+"?ref="+queryRefParam:window.location.protocol + "//" + window.location.host + window.location.pathname;    
        window.history.pushState({ path: refresh }, '', refresh);
      }
  }
  render() {
    const { richiestaNumero } = this.props;
    const assetsPath = `${CONTEXT_ROOT}/assets/images/`;

    return (
      <div className="container">
        <div className="title">Scegli la tua offerta</div>
        {/* <div className="tagline">Richiesta numero {richiestaNumero}</div> */}
        <div className="wrapper">
          <div className="plan">
            <div className="section">
              <div className="title">POS Easy a commissioni</div>
              <div className="img-container flex">
                <img src={assetsPath + "easyflex.png"} alt="Easy Flex" />
              </div>
              <div className="description">
                Zero canone,1% di commissioni.
              </div>
              <ul>
                <li>
                  <b>POS in vendita:</b>
                  <br />  99 € + IVA
                </li>
                <li>
                  <b>Commissioni:</b> 1%
                </li>
                <li>
                  <b>Attivazione:</b> 16 € di bollo
                </li>
                <li>
                  <b>Canone mensile:</b> 0 €
                </li>
              </ul>
            </div>
            <button onClick={() => this.OnFlexProceed()}>Prosegui</button>
          </div>

          <div className="plan">
            <div className="section">
              <div className="title">POS Easy a canone</div>
              <div className="img-container flat">
                <img src={assetsPath + "easyflat.png"} alt="Easy Flat" />
              </div>
              <div className="description">
                Un solo canone, zero commissioni.
              </div>
              <ul>
                <li>
                  <b>POS in comodato d'uso:</b>
                  <br /> incluso nel canone mensile
                </li>
                <li>
                  <b>Commissioni:</b> 0 €
                </li>
                <li>
                  <b>Attivazione:</b> 16 € di bollo
                </li>
                <li>
                  <b>Canone mensile:</b>
                  <br />
                  {/* <div className="maindiv">
                     <div className="innerdiv1">
                       <div className="innersubdivplan">
                          <span className="promocolor">Promo*</span>
                       </div>
                      </div>
                      <div className="innerdiv2">
                        <b>2 mesi di canone gratis</b> can il codice promozionale <b>EASYX2</b>
                      </div>
                  </div> */}
                  17 € + IVA se transi meno di 10.000 € all'anno
                  <br />
                  22 € + IVA se transi tra 10.000 € e 30.000 € all'anno
                </li>
              </ul>
            </div>
            <button onClick={() => this.OnFlatProceed()}>Prosegui</button>
          </div>
        </div>
      </div>
    );
  }
}

export default SelectPlan;



// WEBPACK FOOTER //
// ./components/selectPlan/index.js